import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from 'src/app/services/http.service';

import { BankAccountInterface } from '../interfaces/bankDetails-response.interface';

@Injectable({ providedIn: 'root' })
export class BankDetailsHttpService extends HttpService {
  getBankAccounts(): Observable<BankAccountInterface> {
    return this.http.get<BankAccountInterface>(`${this.baseUrl}banks/accounts`);
  }

  UpdateBankDetail(id: number, data: BankAccountInterface): Observable<any> {
    return this.http.patch(`${this.baseUrl}banks/accounts/${id}`, data, { headers: this.getHeaders() });
  }

  addNewBankDetail(data: BankAccountInterface): Observable<any> {
    return this.http.post(`${this.baseUrl}banks/accounts`, data, { headers: this.getHeaders() });
  }

  getCurrencyFilterData(): Observable<string[]> {
    return this.http.get<string[]>(`${this.baseUrl}currencies`);
  }
}
